
  import { defineComponent, computed, watch } from "vue";
  import LeaguesTablesWidget from "@/components/widgets/Table/LeaguesTablesWidget.vue";
  import KTToolbar from "@/layout/toolbar/Toolbar.vue";
  import { useStore } from "vuex";
  import { Actions } from "@/store/enums/StoreEnums";
  import { useRoute } from "vue-router";
  import FormModal from "@/components/modals/FormModal.vue";
  export default defineComponent({
    name: "CataloguePage",
    components: {
        LeaguesTablesWidget,
        KTToolbar,
        FormModal,
    },
    setup() {
      const store = useStore();
      const route = useRoute();
  
      /****** COMPUTED ******/
      const mapping = computed(() => {
        return store.getters.getMapping({ key: getKey.value });
      });
  
      const breadcrumbs = computed(() => {
        return store.getters.pageBreadcrumbPath;
      });
  
      /****** ACTIONS ******/
  
      store.dispatch(Actions.SETUP_LIST, {
        key: route.meta.key,
        parentID: route.params.id,
      });
      if (route.params.id) {
        store.dispatch(Actions.GET_CATALOGUE_PARENT_CATEGORY, route.params.id);
      }
  
      watch(route, (newRoute) => {
        if (newRoute.path.includes("calatogue")) {
          store.dispatch(Actions.SETUP_LIST, {
            key: newRoute.meta.key,
            parentID: newRoute.params.id ? newRoute.params.id : 0,
          });
  
          store.dispatch(Actions.GET_CATALOGUE_PARENT_CATEGORY, route.params.id);
        }
      });
  
      const getKey = computed(() => {
        return useRoute().meta.key;
      });
  
      return {
        mapping,
        breadcrumbs,
        route,
        getKey,
      };
    },
  });
  